import styled from 'styled-components';

import { FORECASTING_GRAPH_REFERENCES } from 'constants/constants';

const getCardBackground = type =>
  ({
    [FORECASTING_GRAPH_REFERENCES.UNDER_CONTRACT]: '#f8faff',
    [FORECASTING_GRAPH_REFERENCES.PIPELINE_SELECTED]: '#fffdf7',
    [FORECASTING_GRAPH_REFERENCES.TOTAL_FORECAST]: '#ffffff',
    [FORECASTING_GRAPH_REFERENCES.REVENUE_TO_DATE]: '#f8faff',
    [FORECASTING_GRAPH_REFERENCES.YEAR_REVENUE_GOAL]: '#ffffff'
  }[type] || '#ffffff');

const getCardBorderColor = type =>
  ({
    [FORECASTING_GRAPH_REFERENCES.UNDER_CONTRACT]: 'rgba(59, 130, 246, 0.15)',
    [FORECASTING_GRAPH_REFERENCES.PIPELINE_SELECTED]: 'rgba(234, 179, 8, 0.15)',
    [FORECASTING_GRAPH_REFERENCES.TOTAL_FORECAST]: '#e5e7eb',
    [FORECASTING_GRAPH_REFERENCES.REVENUE_TO_DATE]: 'rgba(59, 130, 246, 0.15)',
    [FORECASTING_GRAPH_REFERENCES.YEAR_REVENUE_GOAL]: '#e5e7eb'
  }[type] || '#e5e7eb');

export const Container = styled.div.withConfig({
  shouldForwardProp: prop => prop !== 'type'
})`
  background: ${({ type }) => getCardBackground(type)};
  border: 1px solid ${({ type }) => getCardBorderColor(type)};
  border-radius: 0.8rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
`;

export const Title = styled.span`
  ${({ theme }) => theme.new.typography.p6Medium};
  color: ${({ theme }) => theme.new.colors.neutral600};
  margin-bottom: 0.6rem;
`;

export const Total = styled.span`
  ${({ theme }) => theme.new.typography.p2SemiBold};
  color: ${({ theme }) => theme.new.colors.black};
`;

export const Description = styled.span`
  ${({ theme }) => theme.new.typography.p6};
  color: ${({ theme }) => theme.new.colors.neutral500};
  margin-top: 0.4rem;
`;
